"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkButton = exports.Header = exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("block/base"));

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _userProfile = require("user-profile");

var _LoginForm = require("components/LoginForm");

var _eventDispatcher = babelHelpers.interopRequireDefault(require("event-dispatcher"));

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _animationHelper = require("animation-helper");

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _temp, _class3, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _temp2, _class5, _descriptor10, _temp3;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var HeaderBlock = (_class5 = (_temp3 =
/*#__PURE__*/
function (_Block) {
  babelHelpers.inherits(HeaderBlock, _Block);

  function HeaderBlock() {
    var _babelHelpers$getProt3;

    var _this4;

    babelHelpers.classCallCheck(this, HeaderBlock);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this4 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt3 = babelHelpers.getPrototypeOf(HeaderBlock)).call.apply(_babelHelpers$getProt3, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this4, "header", _descriptor10, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    return _this4;
  }

  babelHelpers.createClass(HeaderBlock, [{
    key: "getChildren",
    value: function getChildren() {
      return _react.default.createElement(Header, this.header);
    }
  }]);
  return HeaderBlock;
}(_base.default), _temp3), (_descriptor10 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "header", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class5);
exports.default = HeaderBlock;
var Header = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(Header, _Component);

  function Header() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, Header);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(Header)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "background", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "summary", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "linkDetails", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "showExtraSignInLink", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    _this.backgroundStyleValue = _base.default.styleForBackgroundObject(_this.background);
    _this.state = {
      userProfile: _this.isLoginButton ? (0, _userProfile.getUserProfileNow)() : null
    };
    return _this;
  }

  babelHelpers.createClass(Header, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.isLoginButton && !this.state.userProfile) (0, _userProfile.getUserProfile)().then(function (userProfile) {
        return _this2.setState({
          userProfile: userProfile
        });
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(newProps) {
      if (newProps.background != this.background) this.backgroundStyleValue = _base.default.styleForBackgroundObject(this.background);
    }
  }, {
    key: "showLoginForm",
    value: function showLoginForm(event) {
      (0, _LoginForm.show)('sign-in').then(function (state) {
        if (state) {
          var modal = state.modal,
              useCustomHome = state.useCustomHome,
              defaultHome = state.defaultHome;
          if (modal) modal.hide();

          if (useCustomHome && location.href.split('?').shift() == defaultHome) {
            if (history.pushState) {
              history.pushState({}, "", useCustomHome);
            }
          }
        }

        (0, _userProfile.userProfileUpdated)(state && state.loggedOut === true).then(function (profile) {
          if (state) {
            (0, _eventDispatcher.default)(state.isNewAccount ? 'account-created' : 'signed-in', profile);
          }
        });
      });
      event.preventDefault();
    }
  }, {
    key: "render",
    value: function render() {
      var content;
      if (this.linkDetails || this.showExtraSignInLink) content = _react.default.createElement("div", {
        className: "inner-content animate-fadeIn"
      }, this.summary && _react.default.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: this.summary
        }
      }), this.linkDetails && _react.default.createElement(LinkButton, _extends({}, this.linkDetails, {
        showLoginForm: this.showLoginForm
      })), this.showExtraSignInLink && _react.default.createElement("span", {
        className: "extra-link-button"
      }, "Already have an account? ", _react.default.createElement("a", {
        onClick: this.showLoginForm,
        href: "javascript:void(0)"
      }, "Sign in")));else content = _react.default.createElement("div", {
        className: "inner-content animate-fadeIn",
        dangerouslySetInnerHTML: {
          __html: this.summary
        }
      });
      return _react.default.createElement("div", {
        className: _classList.default.join('spotlight-header', this.background ? 'variable-background' : null),
        style: this.backgroundStyleValue
      }, content);
    }
  }]);
  return Header;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "background", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "summary", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "linkDetails", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "showExtraSignInLink", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "showLoginForm", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "showLoginForm"), _class.prototype)), _class);
exports.Header = Header;
var LinkButton = (_class3 = (_temp2 =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(LinkButton, _Component2);

  function LinkButton() {
    var _babelHelpers$getProt2;

    var _this3;

    babelHelpers.classCallCheck(this, LinkButton);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this3 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(LinkButton)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this3, "attributes", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "loginButton", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "scrollButton", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "title", _descriptor8, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "showLoginForm", _descriptor9, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    return _this3;
  }

  babelHelpers.createClass(LinkButton, [{
    key: "render",
    value: function render() {
      var extraAttributes = {};

      if (this.loginButton) {
        extraAttributes.onClick = this.showLoginForm;
        extraAttributes.href = 'javascript:void(0)';
      }

      if (this.scrollButton) {
        extraAttributes.onClick = this.scrollIntoView;
        extraAttributes.href = 'javascript:void(0)';
      }

      return _react.default.createElement("a", _extends({}, this.attributes, extraAttributes), this.title);
    }
  }, {
    key: "scrollIntoView",
    value: function scrollIntoView(event) {
      (0, _animationHelper.animateToSelector)("[data-block-id=\"".concat(this.scrollButton, "\"]"));
      event.preventDefault();
    }
  }]);
  return LinkButton;
}(_react.Component), _temp2), (_descriptor5 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "attributes", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "loginButton", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "scrollButton", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "title", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "showLoginForm", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "scrollIntoView", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "scrollIntoView"), _class3.prototype)), _class3);
exports.LinkButton = LinkButton;